import { Currency } from "@bentolabs/kit/entities";
import { formatCurrency } from "@bentolabs/kit/web3";
import { useChainId } from "wagmi";

import { useBentoRateQuery } from "shared/api/use-bento-rate-query";
import {
  createLatestPricesSelect,
  useLatestPricesQuery,
} from "shared/api/use-latest-price-query";
import { mul } from "shared/utils";

export const useUsdRate = (
  currency: Currency | undefined,
  amount: string | undefined
) => {
  const chainId = useChainId();
  const latestPricesQuery = useLatestPricesQuery({
    select: createLatestPricesSelect(chainId),
  });
  const price = currency
    ? latestPricesQuery.data?.[currency.symbol]
    : undefined;

  const bentoRateQuery = useBentoRateQuery({
    enabled: Boolean(
      currency?.symbol === "bentoUSD" || currency?.symbol === "bentoUSD+"
    ),
  });

  if (currency?.symbol === "bentoUSD") {
    return bentoRateQuery.data?.bentoRate
      ? formatCurrency(
          mul(bentoRateQuery.data?.bentoRate, amount || "0").toString()
        )
      : "0";
  }

  if (currency?.symbol === "bentoUSD+") {
    return bentoRateQuery.data?.bentoPlusRate
      ? formatCurrency(
          mul(bentoRateQuery.data?.bentoPlusRate, amount || "0").toString()
        )
      : "0";
  }

  const usdValue = price
    ? formatCurrency(mul(price.formatted, amount || "0").toString())
    : "0";

  return usdValue;
};
